import axios from 'axios';
import prepareRequestOptions from '../utils/admin-apis.util';

export const getListData = async (params = '') => {
  const options = prepareRequestOptions(
    `/admin/subscriptions/list${params}`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const createNewData = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/subscriptions/create',
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const viewDataById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/subscriptions/${id}/view`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const updateDataById = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/subscriptions/${id}/update`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const deleteDataById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/subscriptions/${id}/delete`,
    'DELETE',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const addGraceSubscription = async (payload) => {
  const options = prepareRequestOptions(
    `/admin/subscriptions/grace`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getSubscriptionsNotesList = async (id, params) => {
  const options = prepareRequestOptions(
    `/admin/subscription/${id}/notes/list${params}`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const createSubscriptionsNotes = async (id, data) => {
  const options = prepareRequestOptions(
    `/admin/subscription/${id}/notes/create`,
    'POST',
    data,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const deleteSubscriptionsNote = async (id) => {
  const options = prepareRequestOptions(
    `/admin//subscription/${id}/notes/delete`,
    'DELETE',
    null,
    true
  );
  const response = await axios(options);
  return response.data;
};

export const viewSubscriptionsNotesById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/subscription/${id}/notes/view`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const updateSubscriptionsNotesById = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/subscription/${id}/notes/update`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};
